import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlEndPoints } from '../config/end-points';
import { newUserConfiguration } from '../interfaces/userConfiguration.interfaces';
import { UserConfiguration } from '../models/userConfiguration.model';

@Injectable({
  providedIn: 'root',
})
export class UserConfigurationDal {
  constructor(private readonly httpClient: HttpClient) {}

  getUserConfigurations(): Observable<UserConfiguration> {
    return this.httpClient.get<UserConfiguration>(`${urlEndPoints.userConfigurations}`);
  }

  getAllUserConfigurations(): Observable<UserConfiguration[]> {
    return this.httpClient.get<UserConfiguration[]>(`${urlEndPoints.userConfigurations}getAllUserConfigurations`);
  }

  modifyUserConfigurations(newUserConfiguration: newUserConfiguration): Observable<UserConfiguration> {
    return this.httpClient.patch<UserConfiguration>(`${urlEndPoints.userConfigurations}`, { newUserConfiguration });
  }

  deletePopulation(id: string): Observable<UserConfiguration> {
    return this.httpClient.delete<UserConfiguration>(`${urlEndPoints.userConfigurations}${id}`);
  }
}
